import styled, {css} from "styled-components"

import BrandAvatar from "@irati/ui/src/BrandAvatar"

interface ThumbnailProps {
  compactMode?: boolean
}

export default styled(BrandAvatar)<ThumbnailProps>`
  position: absolute;

  ${({compactMode, theme}) => css`
    box-shadow: ${theme.shadows.mid};
    bottom: -${theme.spacing.two};
    left: ${compactMode ? "50%" : theme.spacing.two};
    transform: translate3d(${compactMode ? "-50%" : 0}, 0, 0);
    background-color: ${theme.colors.utility.white};
  `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet<ThumbnailProps>`
    left: ${({compactMode}) => (compactMode ? "50%" : theme.spacing.four)};
    bottom: -${theme.spacing.three};
    width: 80px;
    height: 80px;
  `}
`
